var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00333E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.02,
    d: "M4.962 12.656H2.344a.47.47 0 0 1-.469-.468V9.569c0-.124.05-.243.137-.331l7.226-7.226a.47.47 0 0 1 .663 0l2.618 2.617a.47.47 0 0 1 0 .663l-7.226 7.227a.47.47 0 0 1-.33.137M7.5 3.75l3.281 3.281"
  })));
};
export default SvgEdit;